module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/reward-tiers/tee-e82f54dabdf919756a4f49df67799193.svg";